import React, { useState, useEffect } from "react";
import "./settings.css";
import { useSidebar } from "../../components/ui/sidebar";
import { useTranslation } from "react-i18next";
import { Sparkles } from "lucide-react";
import { Button } from "../../components/ui/button";
import { Input } from "../../components/ui/input";
import { Label } from "../../components/ui/label";
import { Avatar, AvatarFallback, AvatarImage } from "../../components/ui/avatar";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "../../components/ui/select";
import PageHeader from "../../components/Page/page_header";

function Profile() {
  // Translation hook to support multiple languages
  const { t } = useTranslation();
  // Get the current brand value from the app context
  const { brand, setMode } = useSidebar();
  // State to manage whether the Change Profile Picture modal is open or closed
  // const [isChangeProfileOpen, setChangeProfileOpen] = useState(false);
  // Function to fetch the brand logo based on the brand name
  const fetchBrand = (brandName) => {
    return `${process.env.PUBLIC_URL}/Logos/${brandName}.png`;
  };

  useEffect(() => {
    const mediaQuery = window.matchMedia("(prefers-color-scheme: dark)");
    const handler = (event) => {
      const newColorScheme = event.matches ? "dark" : "light";
      setMode(newColorScheme);
    };
    mediaQuery.addEventListener("change", handler);
    return () => {
      mediaQuery.removeEventListener("change", handler);
    };
  }, []);


  return (
    <div className={"default_page_style my-8 "}>
      <div className="w-full max-w-2xl mx-auto space-y-8 p-6 bg-white/50 dark:bg-[var(--header-color-dark)] rounded-xl border border-zinc-200/80 dark:border-zinc-800/80 shadow-xs">
        <PageHeader title="Profile" />
        <div className="flex items-center justify-center gap-6">
          <Avatar className="h-24 w-24 rounded-full border-2 border-zinc-200/80 dark:border-zinc-800/80 shadow-xs">
            <AvatarImage src={fetchBrand(brand)} className="rounded-full object-cover " />
            <AvatarFallback className="bg-[#b19cd9] dark:bg-zinc-900 text-white font-medium text-lg text-center">{brand}</AvatarFallback>
          </Avatar>
          <Button
            variant="outline"
            className="h-24 w-24 rounded-full border-2 border-dashed border-zinc-200/80 dark:border-zinc-800/80
                             hover:border-zinc-300 dark:hover:border-zinc-700 hover:bg-zinc-50 dark:hover:bg-zinc-900/50
                             transition-colors shadow-sm"
          >
            <Sparkles className="h-6 w-6 text-zinc-600 dark:text-zinc-400" />

          </Button>
        </div>

        <div className="grid gap-6">
          <div className="grid gap-2">
            <Label htmlFor="name" className="text-zinc-700 dark:text-zinc-300">
              Display Name
            </Label>
            <Input
              id="name"
              // placeholder="Your brand name"
              defaultValue={brand}
              autoComplete="off"
              className="bg-white dark:bg-zinc-900/50 border-zinc-200/80 dark:border-zinc-800/80
                                 focus:border-zinc-300 dark:focus:border-zinc-700
                                 focus:ring-1 focus:ring-zinc-200 dark:focus:ring-zinc-800
                                 placeholder:text-zinc-400 dark:placeholder:text-zinc-600 text-black"
            />
          </div>

          <div className="grid gap-2">
            <Label htmlFor="theme" className="text-zinc-700 dark:text-zinc-300">
              Theme
            </Label>
            <p className="text-sm text-zinc-500 dark:text-zinc-400">Choose your preferred color scheme</p>
            <Select defaultValue="system">
              <SelectTrigger className="bg-white dark:bg-zinc-900/50 border-zinc-200/80 dark:border-zinc-800/80 text-black">
                <SelectValue placeholder="Select theme" />
              </SelectTrigger>
              <SelectContent>
                <SelectItem onClick={ () => setMode("system")} value="system">System</SelectItem>
                <SelectItem onClick={ () => setMode("light")} value="light">Light</SelectItem>
                <SelectItem onClick={ () => setMode("dark")} value="dark">Dark</SelectItem>
              </SelectContent>
            </Select>
          </div>

          {/*<div className="grid gap-2">*/}
          {/*  <Label htmlFor="language" className="text-zinc-700 dark:text-zinc-300">*/}
          {/*    Language*/}
          {/*  </Label>*/}
          {/*  <p className="text-sm text-zinc-500 dark:text-zinc-400">Choose your preferred language</p>*/}
          {/*  <Select defaultValue="english">*/}
          {/*    <SelectTrigger className="bg-white dark:bg-zinc-900/50 border-zinc-200/80 dark:border-zinc-800/80 text-black">*/}
          {/*      <SelectValue placeholder="Select language" />*/}
          {/*    </SelectTrigger>*/}
          {/*    <SelectContent>*/}
          {/*      <SelectItem value="english">English</SelectItem>*/}
          {/*      <SelectItem value="german">German</SelectItem>*/}
          {/*      <SelectItem value="dutch">Dutch</SelectItem>*/}
          {/*    </SelectContent>*/}
          {/*  </Select>*/}
          {/*</div>*/}

        </div>
        <div className="flex justify-end gap-4 ">
          <Button  className="bg-purple-700 dark:bg-purple-700 hover:bg-purple-900 dark:hover:bg-purple-900 text-white">
            Cancel
          </Button>
          <Button
              className="bg-purple-700 dark:bg-purple-700 hover:bg-purple-900 dark:hover:bg-purple-900 text-white">Save Changes</Button>
        </div>
      </div>
    </div>
  );
}

export default Profile;
